"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromSearchClickParser = exports.fromSearchParser = exports.fromRecomDetailParser = exports.fromRecomParser = exports.fromBeforeParser = void 0;
const fromBeforeParser = (payload) => {
    const formerDataStr = localStorage.getItem("dclogformer");
    if (formerDataStr) {
        const formerData = JSON.parse(formerDataStr);
        payload.Data.from_log_id = formerData.log_id;
        payload.Data.from_log_type = formerData.log_type;
        payload.Data.from_enter_date = formerData.enter_date;
        if (formerData.recom_json) {
            payload.Data.from_recom_json = formerData.recom_json;
        }
        else if (formerData.recom_detail_json) {
            payload.Data.from_recom_detail_json = formerData.recom_detail_json;
        }
        else if (formerData.query_json) {
            payload.Data.from_query_json = formerData.query_json;
        }
    }
};
exports.fromBeforeParser = fromBeforeParser;
const fromRecomParser = (payload) => {
    const fromRecomLog = localStorage.getItem("from_recom_log");
    if (fromRecomLog) {
        const fromRecomData = JSON.parse(fromRecomLog);
        payload.Data.from_log_id = fromRecomData.log_id;
        payload.Data.from_log_type = fromRecomData.log_type;
        payload.Data.from_enter_date = fromRecomData.enter_date;
        payload.Data.from_recom_json = fromRecomData.recom_json;
    }
};
exports.fromRecomParser = fromRecomParser;
const fromRecomDetailParser = (payload) => {
    const fromRecomDetailLog = localStorage.getItem("from_recom_detail_log");
    if (fromRecomDetailLog) {
        const fromRecomDetailData = JSON.parse(fromRecomDetailLog);
        payload.Data.from_log_id = fromRecomDetailData.log_id;
        payload.Data.from_log_type = fromRecomDetailData.log_type;
        payload.Data.from_enter_date = fromRecomDetailData.enter_date;
        payload.Data.from_recom_detail_json = fromRecomDetailData.recom_detail_json;
    }
};
exports.fromRecomDetailParser = fromRecomDetailParser;
const fromSearchParser = (payload) => {
    const fromLog = localStorage.getItem("dclogformer");
    if (fromLog) {
        const fromData = JSON.parse(fromLog);
        payload.Data.from_log_id = fromData.log_id;
        payload.Data.from_log_type = fromData.log_type;
        payload.Data.from_enter_date = fromData.enter_date;
        payload.Data.from_query_json = fromData.query_json;
    }
};
exports.fromSearchParser = fromSearchParser;
const fromSearchClickParser = (payload) => {
    const fromLog = localStorage.getItem("dclogformer");
    if (fromLog) {
        const fromSearchData = JSON.parse(fromLog);
        payload.Data.from_log_id = fromSearchData.log_id;
        payload.Data.from_log_type = fromSearchData.log_type;
        payload.Data.from_enter_date = fromSearchData.enter_date;
        payload.Data.from_query_json = fromSearchData.query_json;
        if (fromSearchData.query_json) {
            const parsedQueryJson = JSON.parse(fromSearchData.query_json);
            payload.Data.query = parsedQueryJson.query;
        }
    }
};
exports.fromSearchClickParser = fromSearchClickParser;
